import React from 'react';
import { NotAvailableYet } from '@/components/NotAvailableYet';
import { EditButton } from './EditButton';
import { SettingsRow, SettingsSection } from './SettingsGroup';

// Corporate Structure (FIG-320 Purchasing SPV, FIG-324 / REQ-058). Neither the
// merchant → SPV link nor parent/subsidiary links exist yet (UC-219), so the
// rows are shown disabled.

const USE_CASE = 'UC-219';

export const CorporateStructureSection: React.FC<{ canEdit: boolean }> = ({ canEdit }) => (
  <SettingsSection
    title="Corporate Structure"
    description="The SPV that buys this merchant's inventory, and its parent and subsidiaries. Each merchant keeps its own purchase program, Expected Value and Deployed Consideration."
  >
    {[
      { label: 'Purchasing SPV', edit: 'Edit purchasing SPV' },
      { label: 'Parent', edit: 'Edit parent' },
      { label: 'Subsidiaries', edit: 'Add subsidiary' },
    ].map((row) => (
      <SettingsRow
        key={row.label}
        label={row.label}
        action={canEdit ? <EditButton label={row.edit} unavailableUseCase={USE_CASE} /> : null}
      >
        <NotAvailableYet useCase={USE_CASE} />
      </SettingsRow>
    ))}
  </SettingsSection>
);

export default CorporateStructureSection;
